import { NgModule } from '@angular/core';
import { ModusSwitchDirective } from './modus-switch.directive';

@NgModule({
  declarations: [ModusSwitchDirective],
  exports: [ModusSwitchDirective],
})
export class ModusSwitchModule {}
